import { render, staticRenderFns } from "./CreateCase.vue?vue&type=template&id=3cdd477b&"
import script from "./CreateCase.vue?vue&type=script&lang=js&"
export * from "./CreateCase.vue?vue&type=script&lang=js&"
import style0 from "./CreateCase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreateCase.vue"
export default component.exports